import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SanitizeService {
  constructor(private http: HttpClient) {}

  sanitizeBody(body: string): Observable<string> {
    return this.http.post(this.baseUrl(), body ?? '', {
      responseType: 'text',
    });
  }

  private baseUrl(): string {
    return `v2/sanitize-html`;
  }
}
